import styled, { createGlobalStyle } from "styled-components";
import { Input, Select } from "antd";

export const GlobalModalStyles = createGlobalStyle`
  .access-code-modal {
    .ant-modal-content {
      border-radius: 24px !important;
      box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15) !important;
      border: none !important;
      padding: 0 !important;
      overflow: hidden;
    }
    
    .ant-modal-header {
      display: none !important;
    }
    
    .ant-modal-body {
      padding: 0 !important;
    }
    
    .ant-modal-close {
      top: 16px !important;
      right: 16px !important;
      color: #9ca3af !important;
      font-size: 16px !important;
      
      &:hover {
        color: #6b7280 !important;
        background: rgba(107, 114, 128, 0.1) !important;
        border-radius: 8px !important;
      }
    }
  }
`;

export const ModalContent = styled.div`
  padding: 30px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  position: relative;
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: #000;
  margin: 0;
  text-align: center;
  letter-spacing: -0.5px;
`;

export const Description = styled.p`
  font-size: 15px;
  color: #6b7280;
  margin: 0;
  text-align: center;
  line-height: 1.6;
  font-weight: 400;
  max-width: 400px;
  margin: 0 auto;
  white-space: pre-line;
`;

export const InputContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
  padding: 0 20px;
  flex-direction: column;
  gap: 12px;
`;

export const CodeInput = styled(Input)`
  width: 100%;
  height: 70px;
  font-size: 26px;
  font-size: ${(props) => (props.justification ? "16px" : "26px")};
  font-weight: 500;
  text-align: center;
  color: #333;
  background: #ffffff;
  border: none;
  border-radius: 15px;
  padding: 0 20px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.18);

  &:focus {
    outline: none;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.25);
  }

  &::placeholder {
    color: #999;
    font-size: 18px;
  }

  /* Garante que o cursor não apareça */
  cursor: pointer;
  caret-color: transparent;

  /* Previne seleção de texto */
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
`;

export const ReasonSelect = styled(Select)`
  width: 100%;

  .ant-select-selector {
    height: 70px !important;
    border-radius: 15px !important;
    border: none !important;
    padding: 0 20px !important;

    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 18px;
    font-weight: 500;
    color: #333;
    background: #ffffff;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.18);
  }

  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .ant-select-selection-placeholder {
    color: #999;
    font-size: 18px;
  }

  &:hover .ant-select-selector {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.25);
  }

  &.ant-select-focused .ant-select-selector {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.25);
    outline: none;
  }

  cursor: pointer;

  /* Previne cursor e seleção */
  caret-color: transparent;
  user-select: none;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 20px;
  padding: 0 24px;

  .ant-btn {
    flex: 1;
    height: 60px;
    font-weight: 600;
    border-radius: 14px;
    font-size: 18px;
    transition: all 0.3s ease;
    border: 2px solid;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
    }
  }

  .ant-btn:not(.ant-btn-primary) {
    background: #ffffff;
    border-color: #e5e7eb;
    color: #6b7280;

    &:hover {
      border-color: #d1d5db;
      color: #4b5563;
      background: #f9fafb;
    }
  }

  .ant-btn-primary {
    background: #2c3e50;
    border-color: #2c3e50;
    color: white;

    &:hover {
      background: #34495e;
      border-color: #34495e;
    }

    &:disabled {
      background: #f5f5f5;
      border-color: #d9d9d9;
      color: #bfbfbf;
      transform: none;
      box-shadow: none;
    }
  }
`;
